import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('component.header');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-component-header',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/component.header/view.scss */
:host {
  display: block;
  width: 100%;
}

.toast-slide-in {
  animation: toast-in 0.3s ease-out forwards;
}

.toast-fade-out {
  animation: toast-out 0.4s ease-in forwards;
}

@keyframes toast-in {
  0% {
    opacity: 0;
    transform: translateY(-20px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes toast-out {
  0% {
    opacity: 1;
    transform: translateY(0);
  }
  100% {
    opacity: 0;
    transform: translateY(-20px);
  }
}`],
})
export class ComponentHeaderComponent implements OnInit {
    public isLoggedIn: boolean = false;
    public currentUser: any = null;
    public showLoginModal: boolean = false;
    public loginEmail: string = '';
    public loginPassword: string = '';
    public loginError: string = '';
    public loginLoading: boolean = false;
    public showLogoutModal: boolean = false;

    // Toast
    public showToast: boolean = false;
    public toastMessage: string = '';
    public toastFading: boolean = false;

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        this.updateAuthState();
        await this.service.render();
    }

    public updateAuthState() {
        this.isLoggedIn = this.service.auth.status || false;
        if (this.isLoggedIn) {
            this.currentUser = this.service.auth.session;
        }
    }

    // --- Login Modal ---
    public async openLoginModal() {
        this.showLoginModal = true;
        this.loginEmail = '';
        this.loginPassword = '';
        this.loginError = '';
        await this.service.render();
    }

    public async closeLoginModal() {
        this.showLoginModal = false;
        this.loginError = '';
        await this.service.render();
    }

    public async doLogin() {
        if (!this.loginEmail.trim() || !this.loginPassword.trim()) {
            this.loginError = '이메일과 비밀번호를 입력해주세요.';
            await this.service.render();
            return;
        }
        this.loginLoading = true;
        this.loginError = '';
        await this.service.render();

        let res = await wiz.call("login", {
            email: this.loginEmail.trim(),
            password: this.loginPassword.trim()
        });

        this.loginLoading = false;

        if (res.code === 200) {
            this.showLoginModal = false;
            this.isLoggedIn = true;
            this.currentUser = res.data.user;
            this.showToastMessage('로그인이 완료되었습니다.');
        } else {
            this.loginError = res.data?.message || '로그인에 실패했습니다.';
        }
        await this.service.render();
    }

    // --- Logout Modal ---
    public async openLogoutModal() {
        this.showLogoutModal = true;
        await this.service.render();
    }

    public async closeLogoutModal() {
        this.showLogoutModal = false;
        await this.service.render();
    }

    public async confirmLogout() {
        let res = await wiz.call("logout");
        if (res.code === 200) {
            this.isLoggedIn = false;
            this.currentUser = null;
            this.showLogoutModal = false;
            await this.service.render();
        }
    }

    // --- Toast ---
    public async showToastMessage(message: string) {
        this.toastMessage = message;
        this.showToast = true;
        this.toastFading = false;
        await this.service.render();

        setTimeout(async () => {
            this.toastFading = true;
            await this.service.render();
            setTimeout(async () => {
                this.showToast = false;
                this.toastFading = false;
                await this.service.render();
            }, 400);
        }, 2600);
    }
}

export default ComponentHeaderComponent;